"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.safeCatch = void 0;
// Main wrapper function
async function safeCatch(promise) {
    try {
        const data = await promise;
        return { data, error: null };
    }
    catch (error) {
        return { data: null, error: error };
    }
}
exports.safeCatch = safeCatch;
